import { render, staticRenderFns } from "./PaginatedTables.vue?vue&type=template&id=c3c58ad6&scoped=true"
import script from "./PaginatedTables.vue?vue&type=script&lang=js"
export * from "./PaginatedTables.vue?vue&type=script&lang=js"
import style0 from "./PaginatedTables.vue?vue&type=style&index=0&id=c3c58ad6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c58ad6",
  null
  
)

export default component.exports